import { render, staticRenderFns } from "./StaffingPositionDetailsModal.vue?vue&type=template&id=d00bee8e&scoped=true&"
import script from "./StaffingPositionDetailsModal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./StaffingPositionDetailsModal.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./StaffingPositionDetailsModal.vue?vue&type=style&index=0&id=d00bee8e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00bee8e",
  null
  
)

export default component.exports